<template>
	<span>{{printVal}}</span>
</template>

<script>
    export default {
        props: {
            startVal: {
                type: [String, Number],
                default: ''
            },
            endVal: {
                type: [String, Number],
                default: ''
            },
            speed: {
                type: [String, Number],
                default: 5
            },
            decimals: {
                type: [String, Number],
                default: 0
            },
            isReverse: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                start: +this.startVal,
                end: +this.endVal,
                formatSpeed: +this.speed || 5
            };
        },
        computed: {
            formatDecimals() {
                // 是否整数
                let formatDecimals = this.decimals > 0 ? this.decimals : 0;
                return formatDecimals
            },
            decimalsLen() {
                // 1 = 0.001 * decimalsLen(x);
                let decimalsLen = Math.pow(10, this.formatDecimals);
                return decimalsLen;
            },
            printVal() {
                // 保留几位小数
                let start = (
                    parseInt(this.start * this.decimalsLen) / this.decimalsLen
                ).toFixed(this.formatDecimals);
                return start;
            }
        },
        watch: {
            endVal: function(newVal, oldVal){
                this.end = +newVal
                this.accumulativeMachine();
			}
		},
        methods: {
            accumulativeMachine() {
				let that = this
                setTimeout(() => {
					// debugger
                    if (that.isReverse) {
                        let decimals = that.formatDecimals === 0 ? 0 : 1 / that.decimalsLen;
                        let formatSpeed = that.formatSpeed / that.decimalsLen + decimals;
                        that.start -= formatSpeed;
                        if (that.printVal <= that.end) {
                            that.start = that.end;
                            return
                        }
                    } else {
                        let decimals = that.formatDecimals === 0 ? 0 : 1 / that.decimalsLen;
                        let formatSpeed = that.formatSpeed / that.decimalsLen + decimals;
                        that.start += formatSpeed;
                        if (that.printVal >= that.end) {
                            that.start = that.end;
                            return
                        }
                    }
                    that.accumulativeMachine();
                }, 8);
            }
        },
        created() {},
        mounted() {
            this.$nextTick(() => {
                this.accumulativeMachine();
            });
        }
    };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/component/digitalScroll/index.vue